export const PERMS = {
    READ: 'report_trailer_results.read',
    UPDATE: 'report_trailer_results.update',
    DELETE: 'report_trailer_results.delete',
    CREATE: 'report_trailer_results.create',
    EXPORT: 'report_trailer_results.export',
}
